import React from 'react'
import AudioPlayer from '../../../components/AudioPlayer.jsx/AudioPlayer';

const renderPost = (data) => {
    var viewData
   // console.log()
    if (data.multimedia && data.multimedia.type) {
        // if (data.multimedia.type.includes('gif'))
        //     viewData =
        //         <div className="img-post-template">
        //             <GifPlayer
        //                 gif={data.multimedia.url.origin}
        //                 autoplay={false}
        //             />
        //         </div>
        if (data.multimedia?.type.includes('image'))
            viewData =
                <img className='img-post-template' src={data.multimedia.type.includes('gif') ? data.multimedia.url.origin : data.multimedia.url.origin ? data.multimedia.url.origin : data.multimedia.url.origin} alt="" />
        if (data.multimedia?.type.includes('video'))
            viewData =
                <video preload="auto" className="img-post-template" controls poster={data.multimedia.url.thumbnail}>
                    <source src={data.multimedia.url ? data.multimedia.url.medium : data.multimedia.url.origin}></source>
                </video>
        if (data.multimedia?.type.includes('video/hls'))
            viewData =
            <div className="content-post content-not-enable-post">
            <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
        if (data.multimedia.type.includes('audio'))
            viewData =
               <div className='parent-width parent-higth row'>
                    <AudioPlayer url={data.multimedia.url.origin}/>
               </div>
        return (
            viewData
        )
    } else return <></>
}

export { renderPost }